import {Button, Card, Col, Modal, Row, Space, Tag} from "antd";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {globalColorThemeState} from "../../../../../../_common/global_state";
import {useAssignUserVerificationProfile} from "../../../../function/accountVerification";
import {verificationRefetchState} from "../../../../state";
import {extractLocalizedValue} from "../../../../common";

function SelectFlow(props) {
    const {
        userVerificationFlows,
        selectedVerificationType,
        handleSelectVerificationType,
        handleStartVerification,
        goBack
    } = props

    const {t} = useTranslation();
    const colorState = useRecoilValue(globalColorThemeState);
    const {assignUserVerificationProfile} = useAssignUserVerificationProfile();
    const {refetchUserVerificationHistories, refetchUserVerificationProfile} = useRecoilValue(verificationRefetchState)

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const confirmStartVerification = async () => {
        try {
            if (selectedVerificationType) {
                const selectedFlow = userVerificationFlows?.find(flow => flow.verificationType === selectedVerificationType);


                if (!selectedFlow._id) {
                    return;
                }

                const result = await assignUserVerificationProfile(selectedFlow._id);

                if (result?.status === "Success") {
                    handleStartVerification(selectedVerificationType);
                }
            }
        } catch (error) {
            console.error("failed to start verification: ", error)
        } finally {
            closeModal();
        }
    };

    return (
        <>
            <Card bordered={false} className={"shadow-card !mt-6"}>
                <Space style={{width: "100%"}} size={16} direction="vertical">
                    <h6 className="heading">
                        {t("accountVerification.note.selectVerificationType")}
                    </h6>

                    {[...(userVerificationFlows || [])]
                        .sort((a, b) => (a.verificationType === "individual" ? -1 : b.verificationType === "individual" ? 1 : 0))
                        .map((flow) => {
                            const displayName = extractLocalizedValue(flow.displayName) || flow.name;
                            const description = extractLocalizedValue(flow.description);
                            // const logo = flow?.[colorState]?.trim() || "";

                            const isSelected = selectedVerificationType === flow.verificationType;

                            return (
                                <Card
                                    key={flow._id}
                                    onClick={() => handleSelectVerificationType(flow.verificationType)}
                                    className={`account-verification-card-selection verification-card ${isSelected ? "selected" : ""}`}
                                    bodyStyle={{padding: "16px"}}
                                >
                                    <div className={"selection-content-box"}>
                                        <div style={{flex: 1, textAlign: "left"}}>
                                            <Row justify={"space-between"}>
                                                <div className="account-verification-card-selection-title">
                                                    {displayName}
                                                </div>
                                                <Tag className="verification-card-type align-self-start ms-auto"
                                                     color={flow.verificationType === "individual" ? "geekblue" : "lime"}>
                                                    {t(`user.statusTag.${flow.verificationType}`)}
                                                </Tag>
                                            </Row>

                                            {
                                                description &&
                                                <p className="account-verification-card-selection-description">
                                                    {description}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                </Card>
                            );
                        })}

                    <Row gutter={8} className={"mt-6"}>
                        <Col span={12}>
                            <Button className={"secondary_btn"} block onClick={goBack}>
                                {t("common.back")}
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                block
                                className={"primary_btn"}
                                disabled={!selectedVerificationType}
                                onClick={openModal}
                            >
                                {t("accountVerification.startVerification")}
                            </Button>
                        </Col>
                    </Row>
                </Space>
            </Card>

            <Modal
                className="verification-modal"
                title={t("accountVerification.startVerification")}
                open={isModalOpen}
                onCancel={closeModal}
                destroyOnClose
                centered
                footer={
                    <Row gutter={[4,4]} className={"mt-4"}>
                        <Col span={24}>
                            <Button block className={"primary_btn"} onClick={confirmStartVerification}>
                                {t("accountVerification.startVerificationProcess")}
                            </Button>
                        </Col>
                        <Col span={24}>
                            <Button block type={"link"} onClick={closeModal}>{t("common.cancel")}</Button>
                        </Col>
                    </Row>
                }
            >
                <div>{t(`accountVerification.startVerification${selectedVerificationType === "individual" ? "KYC" : "KYB"}Description`)}</div>
            </Modal>
        </>
    );
}

export default SelectFlow;
